/**
 * Status colours for the OKR status distribution donut.
 *
 * Split out of `StatusDistributionChart.tsx` for the same reason as
 * `components/performance/okrStatusBadges.ts`: the S1-g coverage guard
 * (`utils/__tests__/okrStatus.test.ts`) must be able to check this map against the status
 * vocabulary without importing the component, which pulls in `components/common` and its
 * `import.meta`-using ErrorBoundary.
 *
 * Labels come from `utils/okrStatus`; the hex values are chart-specific and stay here.
 */

import { OKR_STATUS_LABELS } from '../../../utils/okrStatus';

export const STATUS_CONFIG: Record<
  string,
  { label: string; color: string; bgColor: string }
> = {
  draft: { label: OKR_STATUS_LABELS.draft, color: '#78716c', bgColor: '#f5f5f4' },
  active: { label: OKR_STATUS_LABELS.active, color: '#0ea5e9', bgColor: '#e0f2fe' },
  on_track: { label: OKR_STATUS_LABELS.on_track, color: '#22c55e', bgColor: '#dcfce7' },
  at_risk: { label: OKR_STATUS_LABELS.at_risk, color: '#f59e0b', bgColor: '#fef3c7' },
  off_track: { label: OKR_STATUS_LABELS.off_track, color: '#ef4444', bgColor: '#fee2e2' },
  completed: { label: OKR_STATUS_LABELS.completed, color: '#10b981', bgColor: '#d1fae5' },
  // S1-g: `closed` is the most common status in the data and had no entry here, so it
  // charted as an unlabelled grey slice carrying the raw string.
  closed: { label: OKR_STATUS_LABELS.closed, color: '#78716c', bgColor: '#f5f5f4' },
  deleted: { label: OKR_STATUS_LABELS.deleted, color: '#a8a29e', bgColor: '#f5f5f4' },
  // Not in the S1-g vocabulary; retained because unmeasured production tenants may hold it.
  cancelled: { label: 'Cancelled', color: '#a8a29e', bgColor: '#f5f5f4' },
};
